<template>
  <div>
    <!-- <Top></Top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">CoolClick 试衣镜</div>
          <div class="contentBottom">
            <div>千人千面 实用型试装对比魔镜</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div
      class="topText"
    >通过感知顾客试穿服装，给予搭配推荐。对于喜爱的衣物犹豫不决时，实时录制试穿效果对比。还原顾客每一个角度的美丽。CC搭载的综合传感器会根据用户交互行为，通过无界式交互设计。适时推荐、赞美、引导。提升顾客试衣购物体验。</div>

    <!-- start -->
    <div class="contentFlex">
      <div class="contentBox">
        <img :src="wawa1" alt>
      </div>
      <div class="contentBox">
        <img :src="wawa2" alt>
      </div>
      <div class="contentBox">
        <img :src="wawa3" alt>
      </div>
      <div class="contentBox">
        <img :src="wawa4" alt>
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle">适用行业</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- iconFlex start -->
    <div class="iconParent">
      <div class="iconFlex">
        <div class="iconBox">
          <img :src="wawaIcon1" alt>
          <div class="iconText">服装</div>
        </div>
        <div class="iconBox">
          <img :src="wawaIcon2" alt>
          <div class="iconText">鞋</div>
        </div>
        <div class="iconBox">
          <img :src="wawaIcon3" alt>
          <div class="iconText">婚纱</div>
        </div>
      </div>
    </div>
    <!-- iconFlex end -->
    <!-- 产品特色 start -->
    <!-- start -->
    <div class="titleBox" style="margin-top:140px">
      <div class="anliTitle">产品特色</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <div class="teSeParent">
      <div class="teSeLeft">
        <img :src="teSeImg1" class="teSeImg" alt>
      </div>
      <div class="teSeRight">
        <div class="teSeTitle">试穿服装感知推荐</div>
        <div class="teSeText">
          顾客试穿服装后，CC试衣镜会感知顾客试穿服装，
          进行搭配推荐。如果选中的搭配产品门店无货，顾客
          可以直接扫码下单，由附近有货门店进行发货配送
          。
        </div>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft teSeLeftTwo">
        <div class="teSeTitle">
                            实时试穿对比
                        </div>
        <div class="teSeText">
                            帮助顾客回顾试穿效果，还原每一个角度的美丽。当试穿太多，顾客犹豫不决时，对比功能可以帮助顾客对比试穿效果。快速决策
                        </div>
      </div>
      <div class="teSeRight teSeRightTwo">
        <img :src="teSeImg2" class="teSeImg" alt>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft">
        <img :src="teSeImg3" class="teSeImg" alt>
      </div>
      <div class="teSeRight">
        <div class="teSeTitle">
                            线上分享
                        </div>
        <div class="teSeText">
                            顾客可以将自己试穿效果solo，DIY成时尚视频通过
手机扫码分享。留存此刻精彩、场外好友把关、品牌
线上传播。
                        </div>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft teSeLeftTwo">
        <div class="teSeTitle">会员转化</div>
        <div class="teSeText">
                            顾客试穿过程中，通过人脸识别技术判断会员属性，
对于非会员发放拉新权益，帮助品牌快速进行会员
转化。
                        </div>
      </div>
      <div class="teSeRight teSeRightTwo">
        <img :src="teSeImg4" class="teSeImg" alt>
      </div>
    </div>
    <!-- 管理平台 start -->
    <!-- start -->
    <div class="titleBox marginTop142">
      <div class="anliTitle">技术优势</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="imgBox minimgBox">
      <div class="imgLeft positionBoxParent">
        <img :src="MPDPImgLeft4" alt class="imgSmallImg">
        <!-- <div class="positionBox">
          <div class="positionTitle">会员识别</div>
          <div class="positionText">通过人脸识别技术，判断用户身份</div>
        </div> -->
      </div>
      <div class="imgRight textRight positionBoxParent">
        <img :src="MPDPImgRight4" alt class="imgSmallImg">
        <!-- <div class="positionBox">
          <div class="positionTitle">感应接入</div>
          <div class="positionText">
            支持接入蓝牙／rfid／NFC等
            <br>智能外设，实现感应识别交互
          </div>
        </div> -->
      </div>
    </div>
    <div class="imgBox minimgBox">
      <div class="imgLeft positionBoxParent">
        <img :src="storageBottom3" alt class="imgSmallImg">
        <!-- <div class="positionBox">
          <div class="positionTitle">数据回流</div>
          <div class="positionText">交互数据统计回流。提供营销指导</div>
        </div> -->
      </div>
      <div class="imgRight textRight positionBoxParent">
        <img :src="storageBottom4" alt class="imgSmallImg">
        <!-- <div class="positionBox">
          <div class="positionTitle">无界式交互</div>
          <div class="positionText">
            灵活的无边框无跳转设计，适时推荐、赞美、
            <br>引导；提示顾客试衣购物体验。
          </div>
        </div> -->
      </div>
    </div>
    <!-- end -->
    <!-- 管理平台 end -->
    <!-- 产品特色 end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/mirrorTop.png";

import wawa1 from "@/assets/images/mirror1.png";
import wawa2 from "@/assets/images/mirror2.png";
import wawa3 from "@/assets/images/mirror3.png";
import wawa4 from "@/assets/images/mirror4.png";

import wawaIcon1 from "@/assets/images/mirrorIcon1.png";
import wawaIcon2 from "@/assets/images/mirrorIcon2.png";
import wawaIcon3 from "@/assets/images/mirrorIcon3.png";

import teSeImg1 from "@/assets/images/mirrorImg1.png";
import teSeImg2 from "@/assets/images/mirrorImg2.png";
import teSeImg3 from "@/assets/images/mirrorImg3.png";
import teSeImg4 from "@/assets/images/mirrorImg4.png";

import MPDPImgLeft4 from "@/assets/images/storageBottom1.png";
import MPDPImgRight4 from "@/assets/images/storageBottom2.png";
import storageBottom3 from "@/assets/images/storageBottom3.png";
import storageBottom4 from "@/assets/images/storageBottom4.png";

import Bread from "@/components/bread.vue";
export default {
  name: "ProductMirror",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["产品", "CC试衣镜"],
      bgImg: bgImg,
      wawa1: wawa1,
      wawa2: wawa2,
      wawa3: wawa3,
      wawa4: wawa4,
      wawaIcon1: wawaIcon1,
      wawaIcon2: wawaIcon2,
      wawaIcon3: wawaIcon3,

      teSeImg1: teSeImg1,
      teSeImg2: teSeImg2,
      teSeImg3: teSeImg3,
      teSeImg4: teSeImg4,
      MPDPImgLeft4: MPDPImgLeft4,
      MPDPImgRight4: MPDPImgRight4,
      storageBottom3: storageBottom3,
      storageBottom4: storageBottom4
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
.topText {
  width: 60%;
  margin: auto;
  max-width: 890px;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 74px;
  margin-bottom: 80px;
}

/* start */
.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 179px;
}

/* end */
.contentFlex {
  width: 70%;
  margin: auto;
  display: flex;
  justify-content: space-around;
}
.contentBox {
  width: 25%;
  text-align: center;
}
.contentBox img {
  width: 90%;
  max-width: 255px;
  margin: auto;
}
.iconParent {
  background: rgba(238, 238, 238, 1);
  margin-top: 56px;
}
.iconFlex {
  display: flex;
  width: 74%;
  margin: auto;
  padding: 84px 0 60px;
}
.iconBox {
  width: 33%;
  text-align: center;
}
.iconBox img {
  width: 80%;
  max-width: 96px;
}
.iconText {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);

  margin-top: 10px;
}
.teSeParent::after {
  content: "";
  display: block;
  clear: both;
}
.teSeParent {
  width: 70%;
  margin: auto;
  margin-top: 75px;
}
.teSeLeft {
  width: 50%;
  float: left;
}
.teSeRight {
  width: 42%;
  float: right;
}
.teSeImg {
  width: 100%;
  /* max-width: 769px; */
}
.teSeTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  margin-top: 17%;
}
.teSeText {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 8%;
  line-height: 30px;
  width: 90%;
}
.teSeLeftTwo {
  width: 42%;
  padding-left: 6.5%;
}
.teSeRightTwo {
  width: 50%;
}
.adminFlex {
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: space-around;
  margin-top: 85px;
}

.adminBox {
  text-align: center;
  position: relative;
  width: 32%;
}
.adminBoxImg {
  width: 100%;
  max-width: 365px;
}

.textBox {
  position: absolute;
  left: calc(50% - 160px);
  bottom: 20px;
}

.adminTitle {
  font-size: 2.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 10px;
}

.adminText {
  width: 320px;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: 400;
  color: rgba(106, 106, 106, 1);
}
.imgBox {
  width: 70%;
  margin: auto;
}
.imgBox::after {
  content: "";
  display: block;
  clear: both;
}
.imgLeft {
  width: 49%;
  float: left;
}
.imgRight {
  width: 49%;
  float: right;
  text-align: right;
}
.imgXiaImg {
  width: 100%;
  max-width: 584px;
}
.marginTop2 {
  margin-top: 2%;
}
.spicial {
  background: #eeeeee;
  margin-top: 54px;
}
.positionBoxParent {
  position: relative;
}
.positionBox {
  position: absolute;
  bottom: 15px;
  text-align: center;
  width: 370px;
  left: calc(50% - 185px);
}
.positionTitle {
  font-size: 2.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 33px;
}
.positionText {
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(106, 106, 106, 1);
}
.imgSmallImg {
  width: 80%;
  /* max-width: 481px; */
  margin-top: 49px;
}
.minimgBox {
  /* min-width: 886px; */
}
</style>



// WEBPACK FOOTER //
// src/view/ProductMirror.vue